module.exports = __webpack_public_path__ + "1261caa5d33dab62e962006b85b140bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/trufocus.png
// module id = 512
// module chunks = 0